import React, { Component, PropTypes } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';

class InsuredType extends Component {

  constructor(props) {
    super(props);
    this.state = {
      option: [],
      isDataLoaded: false
    }
  }

  componentWillMount() {

  }

  render() {
    return (
      <FormGroup controlId="insuredType">
        <Col componentClass={ControlLabel} sm={5}>
          Insured Type
        </Col>
        <Col sm={7}>
                <select
                  className="custom-select"
                  id="insuredType"
                  onChange={this.props.handleChangeInsuredType}
                  value={this.props.insuredType}
                >
                  <option value="">Please select</option>
                  <option value="individual">Individual</option>
                  <option value="corporate">Corporate</option>
                </select>
        </Col>
      </FormGroup>
    )
  }
}

InsuredType.propTypes = {
  handleChangeInsuredType: PropTypes.func,
  insuredType: PropTypes.string
};

export default InsuredType;



// WEBPACK FOOTER //
// ./src/app/components/coverNoteCVComponent/insuredType/InsuredType.js